<script setup lang="ts">
import { computed } from 'vue'

import type { ProfileSelectorItem } from '../../../types/common.types'
import { SocialItemEnum } from '../../../types/socials.types'

import type { SegmentedFilterItem } from './SegmentedFilter.types'
import SegmentedFilter from './SegmentedFilter.vue'

const props = defineProps<{
  profiles: ProfileSelectorItem[]
}>()

const profileRef = defineModel<string | undefined>('profileRef')
const profileId = defineModel<string | undefined>('profileId')

const SUPPORTED_SOCIAL_TYPES = new Set<SocialItemEnum>([SocialItemEnum.Instagram, SocialItemEnum.TikTok, SocialItemEnum.Snapchat])

const filteredProfiles = computed(() => {
  const supported = props.profiles.filter((item) => SUPPORTED_SOCIAL_TYPES.has(item.type))
  return [...supported].sort((a, b) => {
    if (a.isPrimary === b.isPrimary) {
      return 0
    }
    return a.isPrimary ? -1 : 1
  })
})

const items = computed<SegmentedFilterItem<string>[]>(() =>
  filteredProfiles.value.map((profile) => ({
    value: profile.value,
    label: profile.identifier,
    icon: profile.icon,
  })),
)

const selected = computed<string | undefined>({
  get: () => profileRef.value,
  set: (value) => {
    profileRef.value = value
    const match = filteredProfiles.value.find((profile) => profile.value === value)
    profileId.value = match?.profileId ?? undefined
  },
})
</script>

<template>
  <SegmentedFilter v-model="selected" :items="items" />
</template>
